import React from "react";
import { Seo } from "@flogy/gatsby-theme-fgs-layout";

const PageSeo = () => <Seo title="Datenschutzerklärung" />;

export default PageSeo;
